import { FC, SVGProps } from 'react';

const AnalyticsIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M6.48594 2.5H13.5148C15.9716 2.5 17.5 4.23433 17.5 6.68946V13.3113C17.5 15.7665 15.9716 17.5 13.5141 17.5H6.48594C4.02919 17.5 2.5 15.7665 2.5 13.3113V6.68946C2.5 4.23433 4.03648 2.5 6.48594 2.5Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.52832 8.65963V13.805M10.0281 6.19788V13.8049M13.4709 11.3787V13.8046"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AnalyticsIcon;
